function About() {
  return (
    <h1>About page</h1>
  )
}

export {About}